// This file is generated by the openedx/frontend-platform's "intl-import.js" script.
//
// Refer to the i18n documents in https://docs.openedx.org/en/latest/developers/references/i18n.html to update
// the file and use the Micro-frontend i18n pattern in new repositories.
//

import messagesOfAfZaLanguage from './af_ZA.json';
import messagesOfArLanguage from './ar.json';
import messagesOfAzLanguage from './az.json';
import messagesOfBoLanguage from './bo.json';
import messagesOfCaLanguage from './ca.json';
import messagesOfDaLanguage from './da.json';
import messagesOfDeDeLanguage from './de_DE.json';
import messagesOfElLanguage from './el.json';
import messagesOfEs419Language from './es_419.json';
import messagesOfEsEsLanguage from './es_ES.json';
import messagesOfFaLanguage from './fa.json';
import messagesOfFrLanguage from './fr.json';
import messagesOfFrCaLanguage from './fr_CA.json';
import messagesOfHeLanguage from './he.json';
import messagesOfHiLanguage from './hi.json';
import messagesOfHuLanguage from './hu.json';
import messagesOfIdLanguage from './id.json';
import messagesOfItItLanguage from './it_IT.json';
import messagesOfJaLanguage from './ja.json';
import messagesOfKoLanguage from './ko.json';
import messagesOfPlLanguage from './pl.json';
import messagesOfPtBrLanguage from './pt_BR.json';
import messagesOfPtPtLanguage from './pt_PT.json';
import messagesOfRuLanguage from './ru.json';
import messagesOfSvLanguage from './sv.json';
import messagesOfSwLanguage from './sw.json';
import messagesOfTeLanguage from './te.json';
import messagesOfThLanguage from './th.json';
import messagesOfTrTrLanguage from './tr_TR.json';
import messagesOfUkLanguage from './uk.json';
import messagesOfUzLanguage from './uz.json';
import messagesOfZhCnLanguage from './zh_CN.json';

export default {
  'af-za': messagesOfAfZaLanguage,
  'zh-cn': messagesOfZhCnLanguage,
  'uz': messagesOfUzLanguage,
  'uk': messagesOfUkLanguage,
  'tr-tr': messagesOfTrTrLanguage,
  'th': messagesOfThLanguage,
  'te': messagesOfTeLanguage,
  'sw': messagesOfSwLanguage,
  'sv': messagesOfSvLanguage,
  'ru': messagesOfRuLanguage,
  'pt-pt': messagesOfPtPtLanguage,
  'pt-br': messagesOfPtBrLanguage,
  'pl': messagesOfPlLanguage,
  'ko': messagesOfKoLanguage,
  'ja': messagesOfJaLanguage,
  'it-it': messagesOfItItLanguage,
  'id': messagesOfIdLanguage,
  'hu': messagesOfHuLanguage,
  'hi': messagesOfHiLanguage,
  'he': messagesOfHeLanguage,
  'fr-ca': messagesOfFrCaLanguage,
  'fr': messagesOfFrLanguage,
  'fa': messagesOfFaLanguage,
  'es-es': messagesOfEsEsLanguage,
  'es-419': messagesOfEs419Language,
  'el': messagesOfElLanguage,
  'de-de': messagesOfDeDeLanguage,
  'da': messagesOfDaLanguage,
  'ca': messagesOfCaLanguage,
  'bo': messagesOfBoLanguage,
  'az': messagesOfAzLanguage,
  'ar': messagesOfArLanguage,
};
